import { useState } from 'react';
import { toast } from 'sonner';
import { makeContactUseCases } from '../../main/factories/contact-dependencies.factory';
import { CreateContactMessageDTO } from '../../application/dtos/contact/create-contact-message.dto';

const useCases = makeContactUseCases();

export const usePublicContact = () => {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submitMessage = async (data: CreateContactMessageDTO): Promise<boolean> => {
    setSubmitting(true);
    try {
      await useCases.submitPublicContactUseCase.execute(data);
      setSubmitted(true);
      toast.success('¡Consulta enviada exitosamente! Nos pondremos en contacto contigo pronto.');
      return true;
    } catch (error: unknown) {
      const msg =
        error instanceof Error
          ? error.message
          : 'Ocurrió un problema al enviar tu consulta. Por favor inténtalo más tarde.';
      toast.error(msg);
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  const resetForm = () => {
    setSubmitted(false);
  };

  return {
    submitting,
    submitted,
    submitMessage,
    resetForm,
  };
};
